import React from 'react';

import { ReactComponent as IconCandidateExperience } from 'assets/icon-candidate-experience.svg';
import { ReactComponent as IconTaxResidency } from 'assets/icon-tax-residency.svg';
import { ReactComponent as IconCalendar } from 'assets/icon-metro-calendar.svg';
import { ReactComponent as IconMoney } from 'assets/icon-material-attach-money.svg';
import { ReactComponent as IconProfileType } from 'assets/icon-profile-type.svg';

export const ROWS_MAPPER = [
    {
        ICON: <IconProfileType />,
        TITLE: 'Job Position',
        VALUE: 'jobType'
    },
    {
        ICON: <IconCandidateExperience />,
        TITLE: 'Experience',
        VALUE: 'experienceSince',
    },
    {
        ICON: <IconTaxResidency />,
        TITLE: 'Tax Residency',
        VALUE: 'countryOfTax',
    },
    {
        ICON: <IconMoney />,
        TITLE: 'Salary Expectation',
        VALUE: 'salaryValue',
    },
    {
        ICON: <IconCalendar />,
        TITLE: 'Availability',
        VALUE: 'earliestDate',
    },
    {
        ICON: <IconCalendar />,
        TITLE: 'Disable search appearance',
        VALUE: 'isDisabledForSearch'
    }
];

export const REQUIRED_FIELDS = {
    experienceSince: ['experienceSince'],
    countryOfTax: ['countryOfTax'],
    earliestDate: ['earliestDate'],
    netSalaryValue: ['netSalaryValue', 'salaryCurrency'],
    jobType: ['jobType'],
};

export const POSITIVE_FIELDS = {
    netSalaryValue: ['netSalaryValue'],
};
